import PassageHistoryRoutes from '@cobliteam/passage-history/src/routes';

export default PassageHistoryRoutes;
